import { Directive, Input, HostListener, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appHideHeader]',
})
export class HideHeaderDirective implements AfterViewInit {
  @Input('headerRef') private headerRef: any;
  @Input('hideAfterHeight') private hideAfterHeight: number;

  constructor() {}

  public ngAfterViewInit(): void {
    this.headerRef = this.headerRef.el;
  }

  @HostListener('ionScroll', ['$event']) public onContentScroll($event: any): void {
    if ($event?.detail.scrollTop > this.hideAfterHeight) {
      if (this.headerRef.classList.contains('ion-hide')) {
        this.headerRef.classList.remove('ion-hide');
      }
    } else {
      this.headerRef.classList.add('ion-hide');
    }
  }
}
